import React from 'react';
import { useValue } from '../../ValueContext';
import styles from '../../styles';
import MedicalPassportCheckbox from '../../components/MedicalPassportCheckbox';
import MedicalPassportField from '../../components/MedicalPassportField';
import MedicationReconciliationField from '../../components/MedicationReconciliationField';
import GT from '../../../../../../assets/images/GTlogo.png';
import get from 'lodash/get';
import MedicationTextArea from '../../components/MedicationTextArea';
import Barcode from '../../../Barcode';
import toAge from '../../../../../../questionnaire/toAge';
import toSex from '../../../../../../questionnaire/toSex';
import getAgeAndBmi from './pageUtils';

const Page8Extra = ({ formName, pageNumber, showQRCode, defaultValue, answers }) => {
  const { questionnaireAnswers } = useValue();
  const { age } = getAgeAndBmi(
    defaultValue?.demographicInformation?.dob,
    defaultValue?.demographicInformation?.bmi
  );

  const getMedicationList = answers => {
    const [takesMedication, medicationAnswer] = get(answers, 'sections.medications.yes', []) || [];
    return [takesMedication, get(medicationAnswer, 'list', [])];
  };

  const medicationYes = get(questionnaireAnswers, 'sections.medications.yes', []);
  const medicationList = getMedicationList(questionnaireAnswers);
  const medication = medicationList[1];

  const morethan13 = medication.length > 13;
  const morethan28 = medication.length > 28;

  const nameArr = [medication.length];
  const doseArr = [medication.length];
  const freqArr = [medication.length];
  const purposeArr = [medication.length];
  const last = [medication.length];

  for (let i = 0; i < medication.length; i++) {
    nameArr[i] = get(medication[i], 'schema.name.text', '');
    doseArr[i] = get(medication[i], 'schema.dosage.text', '');
    if (get(medication[i], 'schema.frequency.option[1].text', '') !== '') {
      freqArr[i] =
        get(medication[i], 'schema.frequency.option[0]', '') +
        ', ' +
        get(medication[i], 'schema.frequency.option[1].text', '');
    } else if (get(medication[i], 'schema.frequency.option[0]', '') === 'Other') {
      freqArr[i] = get(medication[i], 'schema.frequency.option[0]', '');
    } else {
      freqArr[i] = get(medication[i], 'schema.frequency.option', '');
    }
    purposeArr[i] = get(medication[i], 'schema.purpose.text', '');
    last[i] = get(medication[i], 'schema.last.text', '');
  }

  const allergies = get(questionnaireAnswers, 'sections.allergies.schema.q1.checkboxes', {});
  const latex = get(allergies, 'Allergic to Latex?[0]');
  let medicationFlag = false;
  if (medicationYes.length === 0) {
    medicationFlag = true;
  }
  let latexFlag = false;
  if (latex === true) {
    latexFlag = true;
  }

  if (morethan13) {
    return (
      <div id="page8Extra" className="page" style={{ PaddingTop: '0', paddingBottom: '0', minHeight: '1090px' }}>
        <div style={styles.center}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
            {showQRCode && (
              <Barcode
                formName={formName}
                pageNumber={pageNumber}
                providerId={defaultValue?.procedure?.patient?.providerId}
                serviceTime={defaultValue?.procedure?.serviceTime}
              />
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'left', width: '75px', height: '75px' }}>
            <img src={GT} alt="Hospital Logo" />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              gap: '12px',
            }}
          >
            <strong>
              <div style={{ display: 'flex', alignItems: 'left', fontSize: '24px' }}>Medication Reconciliation</div>
            </strong>
            <div
              style={{
                flexShrink: 0,
                border: '1px solid black',
                padding: '8px',
                lineHeight: '20px',
                fontSize: '13px',
              }}
            >
              <MedicalPassportField name="procedure.patient.name" label="Patient" fontWeight={'bold'} fontSize={14} />
              <MedicalPassportField name="procedure.patient.providerId" label="MRN#" fontSize={12} />
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '40% 60%',
                  alignContent: 'start',
                }}
              >
                <MedicalPassportField name="dob" label="DOB" path={['demographicInformation', 'dob']} fontSize={12} />
                <MedicalPassportField
                  name="age"
                  label="Age"
                  path={['demographicInformation', 'dob']}
                  reducer={toAge}
                  warning={age > 70}
                  fontSize={12}
                />
                <MedicalPassportField name="procedure.serviceTime" label="DOS" fontSize={12} />
                <MedicalPassportField
                  name="sex"
                  label="Sex"
                  path={['demographicInformation', 'sex']}
                  reducer={toSex}
                  fontSize={12}
                />
              </div>
              <MedicalPassportField name="procedure.physician.name" label="Surgeon" fontSize={12} />
              <MedicalPassportField
                name="procedure.pcp"
                path={['demographicInformation', 'primaryCareDoctor']}
                label="PCP"
                fontSize={12}
              />
            </div>
          </div>
          <strong>
            <div style={{ display: 'flex', alignItems: 'left', fontSize: '14px' }}>Allergies</div>
          </strong>
          <div style={{ display: 'flex', alignItems: 'left', fontSize: '12px' }}>
            <input type="checkbox" name="page8.latex" label="Latex Allergy / Sensitivity" id="id" checked={latexFlag} />
            Latex Allergy / Sensitivity
          </div>
          <br></br>
          <div style={{ display: 'flex', alignItems: 'left', fontSize: '12px' }}>
            <input
              type="checkbox"
              name="page8.noMed"
              label="No Current Medications"
              id="id2"
              checked={medicationFlag}
            />
            No Current Medications
          </div>
          <div style={{ ...styles.sectionHeader, fontWeight: 'bold', padding: '2px', fontSize: '14px' }}>
            MEDICATION
          </div>
          <div
            style={{
              lineHeight: '18px',
              display: 'grid',
              gridTemplateColumns: '30% 7.5% 15% 15% 12% 6% 7% 7.5%',
              textAlign: 'center',
              border: '1px solid black',
              borderBottom: 0,
              borderRight: '1px solid black',
              fontWeight: 'bold',
            }}
          >
            <div style={{ borderRight: '1px solid black', fontSize: '12px' }}>Name</div>
            <div style={{ borderRight: '1px solid black', fontSize: '12px' }}>Dose</div>
            <div style={{ borderRight: '1px solid black', fontSize: '12px' }}>Frequency</div>
            <div style={{ borderRight: '1px solid black', fontSize: '12px' }}>Reason</div>
            <div style={{ borderRight: '1px solid black', fontSize: '12px' }}>Last Taken Date & Time</div>
            <div style={{ borderRight: '1px solid black', fontSize: '10px' }}>Continue</div>
            <div style={{ borderRight: '1px solid black', fontSize: '10px' }}>Discontinue</div>
            <div style={{ fontSize: '12px' }}>Date to Resume</div>
          </div>
          {[...Array(15)].map((_, i) => (
            <>
              <div style={{ ...styles.eightColumns2, lineHeight: '15px' }}>
                <div style={{ borderRight: '1px solid black', wordBreak: 'break-all' }}>
                  <MedicationTextArea
                    name={`page8.c${i + 13}.r1`}
                    value={nameArr[i + 13]}
                    style={{ fontSize: '10px' }}
                  />
                </div>
                <div style={{ borderRight: '1px solid black' }}>
                  <MedicationTextArea
                    name={`page8.c${i + 13}.r2`}
                    value={doseArr[i + 13]}
                    style={{ fontSize: '10px' }}
                  />
                </div>
                <div style={{ borderRight: '1px solid black' }}>
                  <MedicationTextArea
                    name={`page8.c${i + 13}.r3`}
                    value={freqArr[i + 13]}
                    style={{ fontSize: '10px' }}
                  />
                </div>
                <div style={{ borderRight: '1px solid black' }}>
                  <MedicationTextArea
                    name={`page8.c${i + 13}.r4`}
                    value={purposeArr[i + 13]}
                    style={{ fontSize: '10px' }}
                  />
                </div>
                <div style={{ borderRight: '1px solid black' }}>
                  <MedicationTextArea name={`page8.c${i + 13}.r5`} style={{ fontSize: '10px' }} />
                </div>
                <div style={{ borderRight: '1px solid black' }}>
                  <div style={{ position: 'relative', left: '30%' }}>
                    <MedicalPassportCheckbox name={`page8.c${i + 13}.r6`} />
                  </div>
                </div>
                <div style={{ borderRight: '1px solid black' }}>
                  <div style={{ position: 'relative', left: '30%' }}>
                    <MedicalPassportCheckbox name={`page8.c${i + 13}.r7`} />
                  </div>
                </div>
                <div>
                  <MedicationReconciliationField name={`page8.c${i + 13}.r8`} />
                </div>
              </div>
            </>
          ))}
          <div
            style={{
              display: 'grid',
              border: '1px solid black',
              borderTop: '1px solid black',
              borderBottom: 0,
              lineHeight: '1.4em',
              padding: '0 0.1rem',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'left', fontSize: '12px' }}>
              <input
                type="checkbox"
                name="page8.continueMedi1"
                label="Medication Reconciliation continued (see additional page)"
                id="medi1"
                checked={morethan28}
              />
              Medication Reconciliation continued (see additional page)
            </div>
          </div>
          <div style={{ ...styles.sectionHeader, fontWeight: 'bold', fontSize: '14px' }}>
            PRESCRIPTIONS GIVEN AT DISCHARGE
          </div>
          <div
            style={{
              lineHeight: '18px',
              display: 'grid',
              gridTemplateColumns: '35% 7.5% 7.5% 12% 18% 20%',
              textAlign: 'center',
              border: '1px solid black',
              borderBottom: 0,
              borderRight: '1px solid black',
              fontWeight: 'bold',
            }}
          >
            <div style={{ borderRight: '1px solid black', fontSize: '12px' }}>Medication</div>
            <div style={{ borderRight: '1px solid black', fontSize: '12px' }}>Dosage</div>
            <div style={{ borderRight: '1px solid black', fontSize: '12px' }}>Route</div>
            <div style={{ borderRight: '1px solid black', fontSize: '12px' }}>Frequency</div>
            <div style={{ borderRight: '1px solid black', fontSize: '12px' }}>Indication</div>
            <div style={{ fontSize: '12px' }}>Last Dose Given</div>
          </div>

          {[...Array(4)].map((_, i) => (
            <>
              <div style={{ ...styles.sixColumns, lineHeight: '13px' }}>
                <div style={{ borderRight: '1px solid black' }}>
                  <MedicationTextArea name={`page8.pres${i}.c1`} style={{ fontSize: '10px' }} />
                </div>
                <div style={{ borderRight: '1px solid black' }}>
                  <MedicationTextArea name={`page8.pres${i}.c2`} style={{ fontSize: '10px' }} />
                </div>
                <div style={{ borderRight: '1px solid black' }}>
                  <MedicationTextArea name={`page8.pres${i}.c3`} style={{ fontSize: '10px' }} />
                </div>
                <div style={{ borderRight: '1px solid black' }}>
                  <MedicationTextArea name={`page8.pres${i}.c4`} style={{ fontSize: '10px' }} />
                </div>
                <div style={{ borderRight: '1px solid black' }}>
                  <MedicationTextArea name={`page8.pres${i}.c5`} style={{ fontSize: '10px' }} />
                </div>
                <div>
                  <MedicationTextArea name={`page8.pres${i}.c6`} style={{ fontSize: '10px' }} />
                </div>
              </div>
            </>
          ))}

          <div style={{ fontSize: '12px' }}>
            <MedicalPassportCheckbox name="copy" label="Copy given to Patient" />
          </div>
          <br></br>
          <strong>
            <div style={{ textAlign: 'left', fontSize: '14px' }}>
              Signature Review of Medications Across the Patient Care Continuum
            </div>
          </strong>
          <div style={{ ...styles.signatureBox1, fontSize: '12px' }}>
            <div>
              <div style={{ paddingTop: '1.5rem' }}>______________________________</div>
              <div>Pre-Op Signature</div>
            </div>
          </div>
          <div style={{ ...styles.signatureBox1, fontSize: '12px' }}>
            <div>
              <div style={{ paddingTop: '1.5rem' }}>______________________________</div>
              <div>PACU Signature</div>
            </div>
            <div>
              <div style={{ marginLeft: '1rem', marginTop: '1.5rem' }}>_______________________________</div>
              <div>Physician Signature</div>
            </div>
          </div>
          <br></br>
          <div style={{ fontSize: '12px' }}>
            Please bring this medication record with you to your physician office/pharmacist
          </div>
        </div>
      </div>
    );
  } else {
    return '';
  }
};

export default Page8Extra;
